import useSWR from 'swr'

import { getInvoicesSummary } from '../../api'
import SummaryCards from '../ui/summaryCards'
import { useAuth } from '../../context/auth'

const TotalInvoicedBox = () => {
  const { user } = useAuth()
  const { data, isLoading } = useSWR('/api/invoices/summary', getInvoicesSummary)

  const currencySymbol = user?.businessDetails?.currency?.symbol

  return (
    <SummaryCards
      data={data ?? null}
      isLoading={isLoading}
      currencySymbol={currencySymbol}
    />
  )
}

export default TotalInvoicedBox
